<!-- <ng-container *ngFor="let order of orders">
<div class="order_detail_accordion" [ngClass]="[orderClass, isOpen ? 'active' : '']">
	<div class="order_detail_accordion-header">
		<div class="header_block_top">
			<div class="header_block_top-top" (click)="toggleAccordion()">
				<h4>Order #{{ order.order_number }}</h4>
				<div class="status_block">
					<div class="order_status" [ngClass]="{
					'order_complete': order.current_status === 'complete',
					'order_new': order.current_status === 'new',
					'order_preparing': order.current_status === 'preparing',
					'order_delivery': order.current_status === 'delivery',
					'order_paid': order.current_status === 'paid'
				}">

						<svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
							<circle cx="4" cy="4" r="4" fill="#18F121" />
						</svg>
						{{ order.current_status }}
					</div>
					<div class="price_block">
						<svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
							<path d="M10.5807 15.0603C10.2774 15.6621 10.0768 16.3152 10 17.0002L16.4197 15.7792C16.7231 15.1774 16.9235 14.5242 17.0004 13.8392L10.5807 15.0603Z" fill="#1AACD9" />
							<path d="M16.4193 12.1209C16.7227 11.5192 16.9232 10.8659 17 10.181L11.9993 11.1326V9.30327L16.4192 8.46287C16.7225 7.86115 16.923 7.20788 16.9999 6.52295L11.9991 7.47376V0.894795C11.2328 1.27975 10.5523 1.79216 9.99912 2.39658V7.85425L7.99915 8.2346V0C7.23288 0.384817 6.55236 0.897366 5.99917 1.50179V8.61482L1.52422 9.46564C1.22085 10.0674 1.02018 10.7206 0.943202 11.4056L5.99917 10.4442V12.748L0.580711 13.7782C0.27735 14.3799 0.0768233 15.0332 0 15.7181L5.67161 14.6397C6.13331 14.5538 6.53013 14.3095 6.78812 13.9734L7.82826 12.5937V12.5934C7.93624 12.4507 7.99915 12.2786 7.99915 12.0932V10.0638L9.99912 9.68349V13.3422L16.4192 12.1207L16.4193 12.1209Z" fill="#1AACD9" />
						</svg>
						{{ order.total_amount }}
					</div>
				</div>
				<div class="arrow">
					<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 32 32" fill="none">
						<path d="M8 12L16 20L24 12" stroke="#393939" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
					</svg>
				</div>
			</div>
			<div class="header_block_top-bottom">
				<ng-container i18n="@@orders.order_history.estimated_delivery_time">Estimated delivery time</ng-container>{{order.timeDelivery}}
			</div>
		</div>

		<div class="header_block_bottom">
			<div class="restaurant_detail_block">
				<img src="{{ order?.logo }}" alt="logo">
				<div class="restaurant_name">
					<span>{{order.restaurantName}}</span>
					<span>{{order.restaurantAddress}}</span>
				</div>
				<div class="dotted_line" *ngIf="order.status !== 'complete'"></div>
				<div class="d-flex gap-2">
					<svg *ngIf="order.status !== 'complete'" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
						<path d="M12 13C13.6569 13 15 11.6569 15 10C15 8.34315 13.6569 7 12 7C10.3431 7 9 8.34315 9 10C9 11.6569 10.3431 13 12 13Z" fill="#EB1461" />
						<path d="M12 22C16 18 20 14.4183 20 10C20 5.58172 16.4183 2 12 2C7.58172 2 4 5.58172 4 10C4 14.4183 8 18 12 22Z" fill="#EB1461" />
						<path d="M12 13C13.6569 13 15 11.6569 15 10C15 8.34315 13.6569 7 12 7C10.3431 7 9 8.34315 9 10C9 11.6569 10.3431 13 12 13Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
						<path d="M12 22C16 18 20 14.4183 20 10C20 5.58172 16.4183 2 12 2C7.58172 2 4 5.58172 4 10C4 14.4183 8 18 12 22Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
					</svg>
					<span *ngIf="order.status !== 'complete'">{{ order.full_address }}</span>
				</div>
			</div>
			<div class="secondary_btn" style="height: 36px;">
				<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
					<path d="M17.6507 7.65C16.8051 6.55151 15.6576 5.72331 14.3487 5.26672C13.0398 4.81014 11.6262 4.74497 10.2808 5.0792C8.93541 5.41342 7.71663 6.13254 6.77354 7.14857C5.83045 8.1646 5.20395 9.43349 4.9707 10.8M18.0007 4V8H14.0007M6.3487 16.35C7.19408 17.4489 8.34151 18.2775 9.65055 18.7344C10.9596 19.1912 12.3734 19.2565 13.719 18.9223C15.0645 18.588 16.2835 17.8687 17.2265 16.8523C18.1696 15.836 18.7959 14.5668 19.0287 13.2M5.9997 20V16H9.9997" stroke="#EB1461" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
				</svg>
				<ng-container i18n="@@orders.order_history.repeat_order">Repeat order</ng-container>
			</div>
		</div>
	</div>

	<div class="order_detail_accordion-body" *ngIf="isOpen">
		<div class="status_history">
			<div class="status_history-header">
				<span i18n="@@orders.order_status_history">Order Status History</span>
				<svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
					<path d="M7.99992 15.1668C11.6818 15.1668 14.6666 12.1821 14.6666 8.50016C14.6666 4.81826 11.6818 1.8335 7.99992 1.8335C4.31802 1.8335 1.33325 4.81826 1.33325 8.50016C1.33325 12.1821 4.31802 15.1668 7.99992 15.1668Z" stroke="#1C6AB6" stroke-linecap="round" stroke-linejoin="round" />
					<path d="M8 11.1667V8.5" stroke="#1C6AB6" stroke-linecap="round" stroke-linejoin="round" />
					<path d="M8 5.8335H8.00667" stroke="#1C6AB6" stroke-linecap="round" stroke-linejoin="round" />
				</svg>
			</div>
			<div class="status_history-title">
				<div class="status_type">
					<div class="order_new order_status" data-status="new" [ngStyle]="{opacity: '1'}">
						<svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
							<circle cx="4" cy="4" r="4" fill="#18F121"></circle>
						</svg>
						New
					</div>
					<span class="">Today 03:30 PM</span>
				</div>
				<div class="horizontal_line"></div>
				<div class="status_type">
					<div class="order_preparing order_status" data-status="preparing" [ngStyle]="{opacity: '0.5'}">
						<svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
							<circle cx="4" cy="4" r="4" fill="#18F121"></circle>
						</svg>
						Preparing
					</div>
					<span class="" [ngStyle]="{display: 'none'}">Today 03:30 PM</span>
				</div>
				<div class="horizontal_line"></div>
				<div class="status_type">
					<div class="order_paid order_status" data-status="paid" [ngStyle]="{opacity: '0.5'}">
						<svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
							<circle cx="4" cy="4" r="4" fill="#18F121"></circle>
						</svg>
						Paid
					</div>
					<span class="" [ngStyle]="{display: 'none'}">Today 03:30 PM</span>
				</div>
				<div class="horizontal_line"></div>
				<div class="status_type">
					<div class="order_delivery order_status" data-status="delivery" [ngStyle]="{opacity: '0.5'}">
						<svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
							<circle cx="4" cy="4" r="4" fill="#18F121"></circle>
						</svg>
						Delivery
					</div>
					<span class="" [ngStyle]="{display: 'none'}">Today 03:30 PM</span>
				</div>
				<div class="horizontal_line"></div>
				<div class="status_type">
					<div class="order_complete order_status" data-status="complete" [ngStyle]="{opacity: '0.5'}">
						<svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
							<circle cx="4" cy="4" r="4" fill="#18F121"></circle>
						</svg>
						Complete
					</div>
					<span class="" [ngStyle]="{display: 'none'}">Today 03:30 PM</span>
				</div>
			</div>
		</div>

		<div class="products_block">
			<h4 i18n="@@orders.order_history.products">Products</h4>
			<div class="products_cards">
				<ng-container *ngFor="let product of order.items | slice:0:visibleCount; trackBy: trackByName">
					<div class="product_card">
						<div class="product_card_body">
							<img src="{{ product.product_image }}" alt="{{ product.item_name }}">
							<div class="product_card_title">
								<div class="product_card_title-head">
									<h6>{{ product.item_name }}</h6>
									<span>{{ product.total_amount }}x</span>
								</div>
								{{ product.item_name }}
								<div class="product_card_price">
									<svg xmlns="http://www.w3.org/2000/svg" width="17" height="18" viewBox="0 0 17 18"
										fill="none">
										<path d="M10.5802 15.5603C10.2769 16.1621 10.0763 16.8152 9.99951 17.5002L16.4192 16.2792C16.7226 15.6774 16.923 15.0242 17 14.3392L10.5802 15.5603Z" fill="#1AACD9" />
										<path d="M16.4193 12.6209C16.7227 12.0192 16.9232 11.3659 17 10.681L11.9993 11.6326V9.80327L16.4192 8.96287C16.7225 8.36115 16.923 7.70788 16.9999 7.02295L11.9991 7.97376V1.3948C11.2328 1.77975 10.5523 2.29216 9.99912 2.89658V8.35425L7.99915 8.7346V0.5C7.23288 0.884817 6.55236 1.39737 5.99917 2.00179V9.11482L1.52422 9.96564C1.22085 10.5674 1.02018 11.2206 0.943202 11.9056L5.99917 10.9442V13.248L0.580711 14.2782C0.27735 14.8799 0.0768233 15.5332 0 16.2181L5.67161 15.1397C6.13331 15.0538 6.53013 14.8095 6.78812 14.4734L7.82826 13.0937V13.0934C7.93624 12.9507 7.99915 12.7786 7.99915 12.5932V10.5638L9.99912 10.1835V13.8422L16.4192 12.6207L16.4193 12.6209Z" fill="#1AACD9" />
									</svg>
									{{ product.total_amount }}
								</div>
							</div>
						</div>
						<button class="secondary_btn" *ngIf="order.status === 'complete'" style="height: 36px;">
							<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
								<path d="M17.6512 7.65C16.8056 6.55151 15.6581 5.72331 14.3492 5.26672C13.0403 4.81014 11.6267 4.74497 10.2813 5.0792C8.9359 5.41342 7.71711 6.13254 6.77402 7.14857C5.83094 8.1646 5.20444 9.43349 4.97119 10.8M18.0012 4V8H14.0012M6.34919 16.35C7.19457 17.4489 8.342 18.2775 9.65103 18.7344C10.9601 19.1912 12.3739 19.2565 13.7195 18.9223C15.065 18.588 16.2839 17.8687 17.227 16.8523C18.1701 15.836 18.7963 14.5668 19.0292 13.2M6.00019 20V16H10.0002" stroke="#EB1461" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
							</svg>
							<ng-container i18n="@@orders.order_history.order_again">Order again</ng-container>
						</button>
					</div>
				</ng-container>
			</div>
			<div class="load_more_btn" *ngIf="products.length > 3 && visibleCount < products.length" (click)="showMoreProducts()">Load More</div>
		</div>

		<div class="pickUp_from_banner" *ngIf="order.status === 'complete'">
			<span>
				<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
					<path d="M10.0002 10.8333C11.3809 10.8333 12.5002 9.71404 12.5002 8.33332C12.5002 6.95261 11.3809 5.83332 10.0002 5.83332C8.61945 5.83332 7.50016 6.95261 7.50016 8.33332C7.50016 9.71404 8.61945 10.8333 10.0002 10.8333Z" stroke="#393939" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
					<path d="M10.0002 18.3333C13.3335 15 16.6668 12.0152 16.6668 8.33332C16.6668 4.65142 13.6821 1.66666 10.0002 1.66666C6.31826 1.66666 3.3335 4.65142 3.3335 8.33332C3.3335 12.0152 6.66683 15 10.0002 18.3333Z" stroke="#393939" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
				</svg>
				<ng-container i18n="@@orders.order_history.pick_up_from">Pick up from</ng-container>
			</span>
			<span>{{order.address}}</span>
		</div>

		<div class="order_totals_container">
			<div class="order_totals">
				<h4 i18n="@@orders.order_history.order_totals">Order Totals</h4>
				<div class="totals_cost">
					<div class="total_cost">
						<span i18n="@@orders.order_history.total_order_cost">Total Order Cost</span>
						<span>
							<strong>
								<svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none">
									<path d="M7.93553 11.2952C7.70801 11.7466 7.55762 12.2365 7.5 12.7502L12.3148 11.8344C12.5423 11.3831 12.6926 10.8932 12.7503 10.3795L7.93553 11.2952Z" fill="#393939" />
									<path d="M12.3145 9.0907C12.542 8.63941 12.6924 8.14946 12.75 7.63576L8.99944 8.34948V6.97745L12.3144 6.34715C12.5419 5.89586 12.6923 5.40591 12.7499 4.89221L8.99932 5.60532V0.671096C8.42462 0.959811 7.91423 1.34412 7.49934 1.79744V5.89069L5.99936 6.17595V0C5.42466 0.288613 4.91427 0.673024 4.49938 1.12634V6.46112L1.14316 7.09923C0.915641 7.55052 0.765133 8.04047 0.707402 8.55417L4.49938 7.83314V9.56097L0.435533 10.3336C0.208013 10.7849 0.0576175 11.2749 0 11.7886L4.25371 10.9798C4.59998 10.9153 4.8976 10.7322 5.09109 10.4801L5.8712 9.44528V9.44507C5.95218 9.33801 5.99936 9.20893 5.99936 9.0699V7.54788L7.49934 7.26262V10.0067L12.3144 9.0905L12.3145 9.0907Z" fill="#393939" />
								</svg>
								120
							</strong>
						</span>
					</div>
					<div class="total_cost">
						<span i18n="@@orders.order_history.delivery_fee">Delivery Fee</span>
						<span>
							<strong>
								<svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none">
									<path d="M7.93553 11.2952C7.70801 11.7466 7.55762 12.2365 7.5 12.7502L12.3148 11.8344C12.5423 11.3831 12.6926 10.8932 12.7503 10.3795L7.93553 11.2952Z" fill="#393939" />
									<path d="M12.3145 9.0907C12.542 8.63941 12.6924 8.14946 12.75 7.63576L8.99944 8.34948V6.97745L12.3144 6.34715C12.5419 5.89586 12.6923 5.40591 12.7499 4.89221L8.99932 5.60532V0.671096C8.42462 0.959811 7.91423 1.34412 7.49934 1.79744V5.89069L5.99936 6.17595V0C5.42466 0.288613 4.91427 0.673024 4.49938 1.12634V6.46112L1.14316 7.09923C0.915641 7.55052 0.765133 8.04047 0.707402 8.55417L4.49938 7.83314V9.56097L0.435533 10.3336C0.208013 10.7849 0.0576175 11.2749 0 11.7886L4.25371 10.9798C4.59998 10.9153 4.8976 10.7322 5.09109 10.4801L5.8712 9.44528V9.44507C5.95218 9.33801 5.99936 9.20893 5.99936 9.0699V7.54788L7.49934 7.26262V10.0067L12.3144 9.0905L12.3145 9.0907Z" fill="#393939" />
								</svg>
								5
							</strong>
						</span>
					</div>
					<div class="total_cost">
						<span>Tax 15%</span>
						<span>
							<strong>
								<svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none">
									<path d="M7.93553 11.2952C7.70801 11.7466 7.55762 12.2365 7.5 12.7502L12.3148 11.8344C12.5423 11.3831 12.6926 10.8932 12.7503 10.3795L7.93553 11.2952Z" fill="#393939" />
									<path d="M12.3145 9.0907C12.542 8.63941 12.6924 8.14946 12.75 7.63576L8.99944 8.34948V6.97745L12.3144 6.34715C12.5419 5.89586 12.6923 5.40591 12.7499 4.89221L8.99932 5.60532V0.671096C8.42462 0.959811 7.91423 1.34412 7.49934 1.79744V5.89069L5.99936 6.17595V0C5.42466 0.288613 4.91427 0.673024 4.49938 1.12634V6.46112L1.14316 7.09923C0.915641 7.55052 0.765133 8.04047 0.707402 8.55417L4.49938 7.83314V9.56097L0.435533 10.3336C0.208013 10.7849 0.0576175 11.2749 0 11.7886L4.25371 10.9798C4.59998 10.9153 4.8976 10.7322 5.09109 10.4801L5.8712 9.44528V9.44507C5.95218 9.33801 5.99936 9.20893 5.99936 9.0699V7.54788L7.49934 7.26262V10.0067L12.3144 9.0905L12.3145 9.0907Z" fill="#393939" />
								</svg>
								5
							</strong>
						</span>
					</div>
					<div class="total_cost total_result">
						<span i18n="@@orders.order_history.total_cost">Total cost</span>
						<strong>
							<span>
								<svg xmlns="http://www.w3.org/2000/svg" width="17" height="18" viewBox="0 0 17 18" fill="none">
									<path d="M10.5802 15.5603C10.2769 16.1621 10.0763 16.8152 9.99951 17.5002L16.4192 16.2792C16.7226 15.6774 16.923 15.0242 17 14.3392L10.5802 15.5603Z" fill="#1AACD9" />
									<path d="M16.4193 12.6209C16.7227 12.0192 16.9232 11.3659 17 10.681L11.9993 11.6326V9.80327L16.4192 8.96287C16.7225 8.36115 16.923 7.70788 16.9999 7.02295L11.9991 7.97376V1.3948C11.2328 1.77975 10.5523 2.29216 9.99912 2.89658V8.35425L7.99915 8.7346V0.5C7.23288 0.884817 6.55236 1.39737 5.99917 2.00179V9.11482L1.52422 9.96564C1.22085 10.5674 1.02018 11.2206 0.943202 11.9056L5.99917 10.9442V13.248L0.580711 14.2782C0.27735 14.8799 0.0768233 15.5332 0 16.2181L5.67161 15.1397C6.13331 15.0538 6.53013 14.8095 6.78812 14.4734L7.82826 13.0937V13.0934C7.93624 12.9507 7.99915 12.7786 7.99915 12.5932V10.5638L9.99912 10.1835V13.8422L16.4192 12.6207L16.4193 12.6209Z" fill="#1AACD9" />
								</svg>
								130
							</span>
						</strong>
					</div>
				</div>
			</div>
			<div class="additional_info" *ngIf="order.status !== 'complete'">
				<h4 i18n="@@orders.order_history.additional_info">Additional info</h4>
				<div class="notify_msg">
					<span>
						<strong>
							<ng-container i18n="@@orders.order_history.please_state_date_and_time_of_pickup">Please state date and time of pickup</ng-container>
						</strong>
					</span>
					<span>Wednesday at 12</span>
				</div>
			</div>
		</div>

		<div class="contact_restaurant">
			<div class="restaurant_detail_block">
				<img src="{{ getImageUrl(order.logo) }}" alt="logo">
				<div class="restaurant_name">
					<span>{{order.restaurantName}}</span>
					<span>{{order.restaurantAddress}}</span>
				</div>
			</div>
			<div class="contact_restaurant-container">
				<div class="contact info-item">
					<ng-container i18n="@@orders.order_history.contact">Contact</ng-container>
					<span>
						<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
							<path d="M12.8173 13.0337L13.1973 12.6562L12.3148 11.7696L11.9364 12.1471L12.8173 13.0337ZM14.4714 12.4979L16.0639 13.3637L16.6598 12.2654L15.0681 11.4004L14.4714 12.4979ZM16.3698 15.0837L15.1864 16.2612L16.0673 17.1471L17.2506 15.9704L16.3698 15.0837ZM14.4648 16.6396C13.2564 16.7529 10.1314 16.6521 6.74645 13.2871L5.86478 14.1729C9.55811 17.8454 13.0739 18.0254 14.5814 17.8846L14.4648 16.6396ZM6.74645 13.2871C3.52061 10.0787 2.98561 7.38123 2.91895 6.21039L1.67061 6.28123C1.75395 7.75456 2.41645 10.7446 5.86478 14.1729L6.74645 13.2871ZM7.89228 8.13706L8.13145 7.89873L7.25145 7.01289L7.01228 7.25039L7.89228 8.13706ZM8.32145 4.86956L7.27145 3.46623L6.27061 4.21623L7.32061 5.61873L8.32145 4.86956ZM3.73728 3.16039L2.42895 4.46039L3.31061 5.34706L4.61811 4.04706L3.73728 3.16039ZM7.45228 7.69373C7.01061 7.25039 7.01061 7.25039 7.01061 7.25206H7.00895L7.00645 7.25539C6.9671 7.29555 6.93166 7.33936 6.90061 7.38623C6.85561 7.45289 6.80645 7.54039 6.76478 7.65123C6.66331 7.93732 6.63803 8.2449 6.69145 8.54373C6.80311 9.26456 7.29978 10.2171 8.57145 11.4821L9.45311 10.5954C8.26228 9.41206 7.97895 8.69206 7.92645 8.35206C7.90145 8.19039 7.92728 8.11039 7.93478 8.09206C7.93895 8.08039 7.94061 8.07956 7.93478 8.08706C7.92743 8.09862 7.91906 8.10949 7.90978 8.11956L7.90145 8.12789C7.89875 8.13048 7.89597 8.13299 7.89311 8.13539L7.45228 7.69373ZM8.57145 11.4821C9.84395 12.7471 10.8014 13.2404 11.5231 13.3504C11.8923 13.4071 12.1898 13.3621 12.4156 13.2779C12.5419 13.2312 12.66 13.1648 12.7656 13.0812C12.78 13.0692 12.7939 13.0567 12.8073 13.0437L12.8131 13.0387L12.8156 13.0362L12.8164 13.0346C12.8164 13.0346 12.8173 13.0337 12.3764 12.5904C11.9348 12.1471 11.9373 12.1462 11.9373 12.1462L11.9389 12.1446L11.9406 12.1429L11.9456 12.1387L11.9539 12.1304C11.964 12.1214 11.9745 12.1131 11.9856 12.1054C11.9939 12.0996 11.9914 12.1021 11.9798 12.1071C11.9589 12.1146 11.8773 12.1404 11.7131 12.1154C11.3681 12.0621 10.6431 11.7787 9.45311 10.5954L8.57145 11.4821ZM7.27145 3.46539C6.42145 2.33206 4.75145 2.15206 3.73728 3.16039L4.61811 4.04706C5.06145 3.60623 5.84811 3.65206 6.27061 4.21623L7.27145 3.46539ZM2.91978 6.21123C2.90311 5.92289 3.03561 5.62123 3.31061 5.34789L2.42811 4.46123C1.98061 4.90623 1.62811 5.53623 1.67061 6.28123L2.91978 6.21123ZM15.1864 16.2612C14.9581 16.4896 14.7114 16.6179 14.4656 16.6404L14.5814 17.8846C15.1939 17.8271 15.6948 17.5187 16.0681 17.1479L15.1864 16.2612ZM8.13145 7.89873C8.95228 7.08289 9.01311 5.79373 8.32228 4.87039L7.32145 5.61956C7.65728 6.06873 7.60728 6.65789 7.25061 7.01373L8.13145 7.89873ZM16.0648 13.3646C16.7456 13.7346 16.8514 14.6062 16.3706 15.0846L17.2523 15.9704C18.3689 14.8596 18.0248 13.0071 16.6606 12.2662L16.0648 13.3646ZM13.1973 12.6571C13.5173 12.3387 14.0323 12.2604 14.4723 12.4987L15.0689 11.4012C14.1656 10.9096 13.0456 11.0454 12.3156 11.7704L13.1973 12.6571Z" fill="#393939" />
						</svg>
						<a href="#">+966 123 456 789</a>
					</span>
					<span>
						<svg xmlns="http://www.w3.org/2000/svg" width="20" height="22" viewBox="0 0 20 22" fill="none">
							<g clip-path="url(#clip0_13284_857)">
								<path d="M0.428125 10.8792C0.427656 12.5727 0.870156 14.2263 1.71156 15.6838L0.347656 20.6637L5.44391 19.3274C6.85347 20.0948 8.43277 20.4968 10.0377 20.497H10.0419C15.3399 20.497 19.6527 16.1858 19.6549 10.8868C19.6559 8.31906 18.6569 5.90453 16.8417 4.08797C15.0269 2.27156 12.6132 1.2707 10.0415 1.26953C4.74281 1.26953 0.430391 5.58047 0.428203 10.8792" fill="url(#paint0_linear_13284_857)" />
								<path d="M0.0835938 10.8763C0.0830469 12.6307 0.541406 14.3434 1.41281 15.8531L0 21.0115L5.27898 19.6273C6.73352 20.4204 8.37117 20.8385 10.0376 20.8391H10.0419C15.53 20.8391 19.9977 16.3729 20 10.8842C20.0009 8.22422 18.9659 5.72289 17.0859 3.84125C15.2057 1.95984 12.7057 0.922969 10.0419 0.921875C4.55281 0.921875 0.0857813 5.3875 0.0835938 10.8763ZM3.22742 15.5931L3.03031 15.2802C2.20172 13.9627 1.76437 12.4402 1.765 10.8769C1.76672 6.31477 5.47953 2.60313 10.045 2.60313C12.2559 2.60406 14.3337 3.46594 15.8966 5.02969C17.4593 6.59359 18.3192 8.6725 18.3187 10.8836C18.3166 15.4457 14.6037 19.1578 10.0419 19.1578H10.0386C8.5532 19.157 7.09641 18.7581 5.82594 18.0043L5.52359 17.825L2.39094 18.6463L3.22742 15.5931Z" fill="url(#paint1_linear_13284_857)" />
								<path d="M7.55156 6.71501C7.36516 6.30071 7.16898 6.29235 6.99172 6.28509C6.84656 6.27884 6.68062 6.2793 6.51484 6.2793C6.34891 6.2793 6.0793 6.34173 5.85141 6.59055C5.62328 6.83962 4.98047 7.44149 4.98047 8.66563C4.98047 9.88977 5.87211 11.0729 5.99641 11.2391C6.12086 11.4049 7.71773 13.9974 10.2468 14.9948C12.3487 15.8236 12.7764 15.6588 13.2326 15.6172C13.6888 15.5758 14.7048 15.0155 14.912 14.4345C15.1195 13.8535 15.1195 13.3556 15.0573 13.2515C14.9951 13.1478 14.8291 13.0856 14.5803 12.9612C14.3315 12.8368 13.1081 12.2348 12.8801 12.1517C12.652 12.0688 12.4861 12.0274 12.3202 12.2765C12.1542 12.5252 11.6777 13.0856 11.5325 13.2515C11.3874 13.4178 11.2422 13.4385 10.9934 13.3141C10.7445 13.1892 9.94313 12.9268 8.99242 12.0792C8.25273 11.4197 7.75336 10.6052 7.6082 10.3561C7.46305 10.1074 7.59266 9.97251 7.71742 9.84852C7.82922 9.73704 7.96633 9.55798 8.09086 9.41274C8.21492 9.26743 8.25633 9.16376 8.3393 8.99782C8.42234 8.83173 8.38078 8.68641 8.31867 8.56196C8.25633 8.43751 7.77281 7.20696 7.55156 6.71501Z" fill="white" />
							</g>
							<defs>
								<linearGradient id="paint0_linear_13284_857" x1="965.711" y1="1940.68" x2="965.711" y2="1.26953" gradientUnits="userSpaceOnUse">
									<stop stop-color="#1FAF38" />
									<stop offset="1" stop-color="#60D669" />
								</linearGradient>
								<linearGradient id="paint1_linear_13284_857" x1="1000" y1="2009.88" x2="1000" y2="0.921875" gradientUnits="userSpaceOnUse">
									<stop stop-color="#F9F9F9" />
									<stop offset="1" stop-color="white" />
								</linearGradient>
								<clipPath id="clip0_13284_857">
									<rect width="20" height="20.1562" fill="white" transform="translate(0 0.921875)" />
								</clipPath>
							</defs>
						</svg>
						<a href="#">https://wa.me/+966 123 456 789</a>
					</span>
				</div>
				<div class="working_hours info-item">
					<ng-container i18n="@@orders.order_history.working_hours">Working hours</ng-container>
					<span>
						<ng-container i18n="@@orders.order_history.mon_fri">Mon - Fri</ng-container>
						<div class="working_time">
							<span>9:00 to 13:00</span>
							<span>14:00 to 21:00</span>
						</div>
					</span>
				</div>
			</div>
		</div>
	</div>
</div>
</ng-container> -->

<ng-container *ngIf="orders?.length > 0; else noOrders">
  <ng-container *ngFor="let order of orders | paginate: paginator; index as i">
    <order-detail-accordion
      [order]="order"
      [products]="order.items">
    </order-detail-accordion>
  </ng-container>
</ng-container>

<ng-template #noOrders>
	<div class="no-order-history">
		<ng-container *ngIf="tableSection == 'track_order'; else noOrderHistory">
			<svg xmlns="http://www.w3.org/2000/svg" width="157" height="192" viewBox="0 0 157 192" fill="none">
				<g filter="url(#filter0_f_11927_87286)">
					<rect x="24.3123" y="157" width="108.5" height="10.5" fill="#1B3554"/>
				</g>
				<rect x="25.187" y="13.5001" width="108.5" height="69.125" fill="#E0E5EC"/>
				<path fill-rule="evenodd" clip-rule="evenodd" d="M25.1875 13.5001V118.5H7.6875V55.0071L16.4389 41.5756L25.1875 13.5001Z" fill="#CFD4DC"/>
				<path fill-rule="evenodd" clip-rule="evenodd" d="M132.813 13.5001V118.5H150.313V55.0071L141.561 41.5756L132.813 13.5001Z" fill="#CFD4DC"/>
				<path d="M7.6875 54.6249H150.312V173C150.312 175.761 148.074 178 145.312 178H12.6875C9.92607 178 7.6875 175.761 7.6875 173V54.6249Z" fill="#E3F1FF"/>
				<path opacity="0.5" fill-rule="evenodd" clip-rule="evenodd" d="M50.5618 103.229C50.5618 102.617 50.8762 102.048 51.4202 101.767C52.631 101.141 54.9443 100.125 57.1923 100.125C59.4395 100.125 61.6867 101.141 62.8577 101.766C63.3853 102.048 63.6867 102.606 63.6867 103.204C63.6867 104.613 62.0642 105.537 60.7386 105.059C59.6737 104.676 58.4216 104.366 57.1592 104.366C55.8719 104.366 54.5845 104.689 53.4932 105.082C52.1701 105.56 50.5618 104.636 50.5618 103.229Z" fill="#1B3554"/>
				<path opacity="0.5" fill-rule="evenodd" clip-rule="evenodd" d="M95.1877 103.229C95.1877 102.617 95.5022 102.048 96.0462 101.767C97.257 101.141 99.5702 100.125 101.818 100.125C104.066 100.125 106.313 101.141 107.484 101.766C108.011 102.048 108.313 102.606 108.313 103.204C108.313 104.613 106.69 105.537 105.365 105.059C104.3 104.676 103.048 104.366 101.785 104.366C100.498 104.366 99.2105 104.689 98.1192 105.082C96.7961 105.56 95.1877 104.636 95.1877 103.229Z" fill="#1B3554"/>
				<ellipse opacity="0.5" cx="79.4368" cy="121.128" rx="14" ry="6.12765" fill="#1B3554"/>
				<ellipse opacity="0.149343" cx="47.0625" cy="67.7501" rx="5.24999" ry="5.25" fill="#1B3554"/>
				<ellipse opacity="0.149343" cx="110.937" cy="67.7501" rx="5.24999" ry="5.25" fill="#1B3554"/>
				<path d="M47.062 67.481V34.9375C47.062 17.2989 61.3609 3 78.9995 3C96.638 3 110.937 17.2989 110.937 34.9375V67.481" stroke="#5E7085" stroke-width="5" stroke-linecap="round" stroke-linejoin="round"/>
				<defs>
					<filter id="filter0_f_11927_87286" x="0.125311" y="132.813" width="156.874" height="58.8739" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
					<feFlood flood-opacity="0" result="BackgroundImageFix"/>
					<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
					<feGaussianBlur stdDeviation="12.0935" result="effect1_foregroundBlur_11927_87286"/>
					</filter>
				</defs>
			</svg>
			<span class="heading" i18n="@@orders.dont_have_order">You don’t have any current orders</span>
			<span class="desc" i18n="@@orders.once_place_order">Once you place an order, you can track it here!</span>
			<a href="javascript:;" (click)="backToStore()" class="btn tu-btn disabled">
				<span i18n="@@orders.place_order_now">Place and order now!</span>
			</a>
		</ng-container>
		<ng-template #noOrderHistory>
			<svg xmlns="http://www.w3.org/2000/svg" width="204" height="168" viewBox="0 0 204 168" fill="none">
				<path d="M171.655 43.5811H52.8442C51.2413 43.5821 49.7043 44.2193 48.5709 45.3527C47.4375 46.4861 46.8003 48.0231 46.7993 49.626V158.636C46.8003 160.239 47.4375 161.776 48.5709 162.909C49.7043 164.043 51.2413 164.68 52.8442 164.681H171.655C173.258 164.68 174.795 164.043 175.928 162.909C177.062 161.776 177.699 160.239 177.7 158.636V49.626C177.699 48.023 177.062 46.4859 175.928 45.3525C174.795 44.2191 173.258 43.5819 171.655 43.5811Z" fill="#B9DCFF"/>
				<path d="M163.834 126.8H60.6669C57.3287 126.8 54.6221 124.094 54.6221 120.756V24.4397C54.6221 21.1014 57.3287 18.3948 60.6669 18.3948H163.834C167.172 18.3948 169.878 21.1014 169.878 24.4397V120.756C169.878 124.094 167.172 126.8 163.834 126.8Z" fill="#E0E5EC"/>
				<path d="M56.5359 122.669V26.3535C56.5359 23.0153 59.2425 20.3087 62.5808 20.3087H165.747C166.927 20.3087 168.023 20.6514 168.952 21.235C167.883 19.5309 165.993 18.3948 163.834 18.3948H60.6669C57.3287 18.3948 54.6221 21.1014 54.6221 24.4397V120.756C54.6221 122.916 55.7581 124.805 57.4622 125.875C56.8786 124.945 56.5359 123.849 56.5359 122.669V122.669Z" fill="white"/>
				<path d="M151.14 38.7449H73.3611V43.1774H151.14V38.7449ZM151.14 55.6698H73.3611V60.1023H151.14V55.6698ZM151.14 72.5984H73.3611V77.0309H151.14V72.5984ZM151.14 89.5233H73.3611V93.9564H151.14V89.5233Z" fill="#7F93A9"/>
				<path d="M82.6299 75.2163L102.175 94.7617H82.6299V75.2163Z" fill="url(#paint0_linear_11927_87347)"/>
				<path d="M177.701 96.3738V51.4037L169.879 43.5811V96.3732H177.701V96.3738Z" fill="#B9DCFF"/>
				<path d="M186.863 100.442L178.435 160.099C178.014 163.081 175.461 165.298 172.45 165.298H52.0503C49.0385 165.298 46.4861 163.081 46.0647 160.099L34.676 79.4874C34.1622 75.8482 36.9862 72.5967 40.6615 72.5967H77.8433C80.8552 72.5967 83.4076 74.8133 83.8289 77.7951L85.3214 88.3518C85.7427 91.3343 88.2951 93.5508 91.307 93.5508H180.878C184.552 93.5508 187.377 96.8024 186.863 100.442H186.863Z" fill="#E3F1FF"/>
				<path d="M157.003 138.688H67.4979C67.0073 138.688 66.5336 138.509 66.1656 138.185C65.7975 137.86 65.5604 137.413 65.4985 136.926L64.3787 128.06C64.3431 127.776 64.3683 127.488 64.4525 127.215C64.5367 126.942 64.678 126.69 64.8671 126.475C65.0561 126.261 65.2886 126.089 65.5491 125.971C65.8097 125.854 66.0922 125.793 66.3781 125.793H158.123C158.409 125.793 158.691 125.854 158.952 125.971C159.212 126.089 159.445 126.261 159.634 126.475C159.823 126.69 159.964 126.942 160.048 127.215C160.133 127.488 160.158 127.776 160.122 128.06L159.002 136.926C158.941 137.413 158.703 137.86 158.335 138.185C157.967 138.509 157.494 138.688 157.003 138.688Z" fill="#7F93A9"/>
				<defs>
					<linearGradient id="paint0_linear_11927_87347" x1="95.543" y1="97.8977" x2="71.9184" y2="74.2738" gradientUnits="userSpaceOnUse">
					<stop stop-color="#C2CECE" stop-opacity="0"/>
					<stop offset="0.179" stop-color="#AFBCBC" stop-opacity="0.179"/>
					<stop offset="1" stop-color="#5B6A6A"/>
					</linearGradient>
				</defs>
			</svg>
			<span class="heading" i18n="@@orders.havent_order">You haven’t made any orders yet</span>
		</ng-template>
	</div>	
</ng-template>

<!-- paginator  -->
<ng-container *ngIf="paginator.totalItems > paginator.itemsPerPage">
	<div class="pagination_wrapper">
		<div class="showing_results">
			<div class="select_wrapper">
				<ng-container i18n="@@show">Show</ng-container>
				<select class="select-link tab-links-select" id="tab-links-select" nice-select [(ngModel)]="paginator.itemsPerPage" (change)="onChangeItemsPerPage($event, p)">
					<option *ngFor="let option of itemsPerPageOptions" [value]="option">{{ option }}</option>
				</select>
				<ng-container i18n="@@items">items</ng-container>
			</div>
			<div class="results_list" *ngIf="paginator?.from || paginator?.to">
				<ng-container i18n="@@showing_from">Showing from</ng-container> {{ paginator?.from }} <ng-container i18n="@@to">to</ng-container> {{ paginator?.to }} <ng-container i18n="@@of">of</ng-container> {{ paginator?.totalItems }} <ng-container i18n="@@items">items</ng-container>
			</div>
		</div>
		<nav pagination-template #p="paginationApi" [id]="paginator.id" (pageChange)="getPage($event)" aria-label="...">
			<ul class="pagination justify-content-center">
				<li class="page-item" [class.disabled]="p.isFirstPage()">
					<a *ngIf="!p.isFirstPage()" class="page-link prev" tabindex="-1" (click)="p.previous()">
						<svg width="7.5" height="20">
							<path d="M6.75 12.75l-6-6 6-6" fill="none" class="color-stroke" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" />
						</svg>
					</a>
				</li>
				<li *ngFor="let page of p.pages" class="page-item" [class.active]="p.getCurrent() === page.value">
					<a *ngIf="p.getCurrent() !== page.value" (click)="p.setCurrent(page.value)" class="page-link">
						<span>{{ page.label }}</span>
					</a>
					<a *ngIf="p.getCurrent() === page.value" class="page-link">
						{{page.label}} <span class="sr-only">(current)</span>
					</a>
				</li>
				<li class="page-item" [class.disabled]="p.isLastPage()">
					<a *ngIf="!p.isLastPage()" (click)="p.next()" class="page-link next">
						<svg width="7.5" height="20">
							<path d="M.75.75l6 6-6 6" fill="none" class="color-stroke" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" />
						</svg>
					</a>
				</li>
			</ul>
		</nav>
	</div>
</ng-container>
<!-- paginator  -->
